// utils/Stats.js

export const aggregateStats = (events) => {
  const totalStats = {
    total_visitors: 0,
    total_matches: 0,
    total_downloads: 0,
  };

  const photoStats = {
    total_images: 0,
    used_memory: 0,
  };

  const socialStats = {};

  events.forEach((event) => {
    const stats = event?.stats || {};
    const photo = event?.storage || {};
    const socials = event?.social_stats || {};

    // Aggregate general stats
    totalStats.total_visitors += stats.total_visitors || 0;
    totalStats.total_matches += stats.total_matches || 0;
    totalStats.total_downloads += stats.total_downloads || 0;

    // Aggregate photo stats
    photoStats.total_images += photo.total_images || 0;
    photoStats.used_memory += photo.used_memory || 0;

    // Aggregate social stats (now supports object format)
    Object.entries(socials).forEach(([platform, total]) => {
      if (!platform) return;
      if (!socialStats[platform]) {
        socialStats[platform] = 0;
      }
      socialStats[platform] += total || 0;
    });
  });

  // console.log("Aggregated Stats:", {
  //   totalStats,
  //   photoStats,
  //   socialStats,
  // });

  return {
    totalStats,
    photoStats,
    socialStats,
  };
};
